var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextMonth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67182 5C7.7949 5.0392 7.88158 5.12829 7.96825 5.21916C8.9321 6.21162 9.89595 7.2023 10.8598 8.19119C10.9777 8.31235 11.0331 8.45133 10.9794 8.61704C10.9586 8.6794 10.9187 8.73998 10.8737 8.78631C9.87515 9.81619 8.87489 10.8443 7.87464 11.8706C7.70649 12.0434 7.48806 12.0416 7.31991 11.8742C7.24017 11.7958 7.16043 11.7156 7.08762 11.6301C6.96627 11.4839 6.9732 11.2826 7.09455 11.1365C7.11362 11.1133 7.13442 11.0937 7.15349 11.0724C7.96652 10.2367 8.77955 9.39925 9.59431 8.56359C9.61338 8.54399 9.63592 8.52795 9.67059 8.47984C9.64632 8.46737 9.61858 8.45846 9.60125 8.44064C8.77955 7.59786 7.95959 6.75329 7.13789 5.90871C6.98534 5.75192 6.95414 5.53454 7.08068 5.38665C7.20897 5.2352 7.33031 5.07127 7.52447 5C7.57474 5 7.62328 5 7.67182 5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextMonth);
export default __webpack_public_path__ + "static/media/nextMonth.044725093730df0105d650d255a4e351.svg";
export { ForwardRef as ReactComponent };